module.exports = __webpack_public_path__ + "static/img/qiye4.2925343.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/qiye4.png
// module id = X5D+
// module chunks = 52